import { useState, useEffect } from "react";
import { Briefcase, MapPin } from "lucide-react";
import { getAllJobs } from "../../Api";

const OpportunitiesSection = ({ language = "EN" }) => {
  const [jobs, setJobs] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [loading, setLoading] = useState(true);

  const langKey = language === "CN" ? "zh" : "en";

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await getAllJobs();

        if (res.data.success) {
          const activeJobs = res.data.data.filter(job => job.isActive);
          setJobs(activeJobs);

          if (activeJobs.length > 0) {
            setActiveId(activeJobs[0]._id);
          }
        }
      } catch (error) {
        console.error("Jobs Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  const toggleBox = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  if (loading) {
    return (
      <section className="py-10 text-center font-semibold">
        Loading Opportunities...
      </section>
    );
  }

  return (
    <section className="bg-white mb-10">
      <div className="max-w-6xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-10">
          <h2 className="text-[34px] font-medium text-[#154059] leading-snug">
            {language === "CN" ? "当前机会" : "Current Opportunities"}
          </h2>

          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            {language === "CN"
              ? "迈入一个既重视专业卓越又追求个人成长的职业生涯。您的旅程从这里开始。"
              : "Step into a career that values both professional excellence and personal fulfillment. Your journey starts here."}
          </p>
        </div>

        {/* Cards */}
        <div className="space-y-6">
          {jobs.map((job) => (
            <div
              key={job._id}
              className={`group border p-8 transition-all duration-300 ${
                activeId === job._id
                  ? "border-[#C69C6D]"
                  : "border-gray-300 hover:border-[#C69C6D]"
              }`}
            >
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">

                {/* Left Content */}
                <div>
                  <h3
                    className={`text-[24px] font-semibold transition-colors duration-300 ${
                      activeId === job._id
                        ? "text-[#C69C6D]"
                        : "text-[#154059] group-hover:text-[#C69C6D]"
                    }`}
                  >
                    {job.title?.[langKey]}
                  </h3>

                {/* Icons Row */}
<div className="flex items-center gap-6 text-sm text-gray-500 mt-3 flex-wrap">

  <div className="flex items-center gap-2">
    <Briefcase size={16} className="text-[#C69C6D]" />
    <span className="font-semibold text-gray-700">
      {job.jobType?.[langKey]}
    </span>
  </div>

  <div className="flex items-center gap-2">
    <MapPin size={16} className="text-[#C69C6D]" />
    <span className="font-semibold text-gray-700">
      {job.location?.[langKey]}
    </span>
  </div>

</div>
                  <p className="text-gray-600 mt-4 text-[15px]">
                    {job.shortDescription?.[langKey]}
                  </p>
                </div>

                {/* Button */}
               <button
  onClick={() => toggleBox(job._id)}
  className={`px-6 py-2 rounded-full whitespace-nowrap border text-sm font-medium transition-all duration-300 shrink-0 ${
    activeId === job._id
      ? "bg-[#154059] text-white border-[#154059]"
      : "border-[#154059] text-[#154059] hover:bg-[#154059] hover:text-white"
  }`}
>
                  {activeId === job._id
                    ? language === "CN"
                      ? "隐藏详情"
                      : "Hide Details"
                    : language === "CN"
                    ? "查看详情"
                    : "View Details"}
                </button>
              </div>

              {/* Expanded Section */}
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  activeId === job._id
                    ? "max-h-[1000px] opacity-100 mt-8"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="pt-6 border-t border-gray-200 space-y-8">

                  {/* Roles */}
                  <div>
                    <h4 className="text-[#154059] font-semibold mb-4">
                      {language === "CN"
                        ? "你将负责："
                        : "What You’ll Do:"}
                    </h4>

                    <ul className="list-disc pl-6 space-y-3 text-gray-700">
                      {job.roles?.[langKey]?.map((role, index) => (
                        <li key={index}>{role}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div>
                    <h4 className="text-[#154059] font-semibold mb-4">
                      {language === "CN"
                        ? "你将获得"
                        : "What You’ll Gain:"}
                    </h4>

                    <ul className="list-disc pl-6 space-y-3 text-gray-700">
                      {job.benefits?.[langKey]?.map((benefit, index) => (
                        <li key={index}>{benefit}</li>
                      ))}
                    </ul>
                  </div>

                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OpportunitiesSection;